import { Button, Group, Modal, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export interface LockedSectionPrerequisite {
  id: string;
  label: string;
  isMet: boolean;
  actionLabel: string;
  onAction: () => void;
}

export interface LockedSectionModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  description: string;
  prerequisites: LockedSectionPrerequisite[];
}

export function LockedSectionModal(props: LockedSectionModalProps) {
  const { t } = useTranslation();

  return (
    <Modal opened={props.opened} onClose={props.onClose} title={props.title} size="md" centered>
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          {props.description}
        </Text>

        <Stack gap="xs">
          {props.prerequisites.map((prereq) => (
            <Group key={prereq.id} justify="space-between" wrap="nowrap" gap="sm">
              <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
                <ThemeIcon
                  variant="light"
                  color={prereq.isMet ? 'teal' : 'red'}
                  radius="xl"
                  size={28}
                >
                  {prereq.isMet ? <IconCheck size={16} /> : <IconX size={16} />}
                </ThemeIcon>
                <Text size="sm" style={{ flex: 1 }}>
                  {prereq.label}
                </Text>
              </Group>
              {!prereq.isMet && (
                <Button variant="light" size="xs" onClick={prereq.onAction}>
                  {prereq.actionLabel}
                </Button>
              )}
            </Group>
          ))}
        </Stack>

        <Group justify="flex-end">
          <Button variant="subtle" onClick={props.onClose}>
            {t('formEdit.lockModalClose')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
